export const easeIn = (t, alpha) => Math.pow(t, alpha);